import Modal, { ModalProps } from "antd/lib/modal";
import React, { FC, useCallback, useEffect } from "react";
import { LeftOutlined, CloseOutlined } from "@ant-design/icons";
import { useMediaSize } from "@/hooks/useMediaSize";
import styles from "./styles.moduls.less";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

export interface AuthingModalProps extends ModalProps {
  onCancel?: (e?: React.MouseEvent<HTMLElement>) => void;
  okButtonProps?: any;
}

export const AuthingModal: FC<AuthingModalProps> = (props) => {
  const { t } = useTranslation();

  const { isPhoneMedia } = useMediaSize();
  const changeCallBack = useCallback(() => {
    window.removeEventListener("popstate", changeCallBack);

    props.onCancel?.();
  }, [props.onCancel]);

  useEffect(() => {
    if (isPhoneMedia && props.visible) {
      window.history.pushState(null, "", document.URL);
      window.addEventListener("popstate", changeCallBack);
    }

    return () => {
      window.removeEventListener("popstate", changeCallBack);
    };
  }, [changeCallBack, isPhoneMedia, props, props.visible]);

  return (
    <Modal
      transitionName={isPhoneMedia ? "slide-right" : "zoom"}
      closeIcon={isPhoneMedia ? <LeftOutlined /> : <CloseOutlined />}
      okText={t("common.confirm")}
      cancelText={t("common.cancel")}
      {...props}
      onCancel={() => {
        // TODO 有点小问题 等待解决 暂时先这个样子
        props.onCancel?.();
        isPhoneMedia && window.history.back();
      }}
      className={(classnames(styles.authingModal), props.className)}
    />
  );
};
